/**
 * Eticheta tastei modificatoare, după platformă.
 *
 * `⌘` e simbolul tastei Command și **există doar pe Apple**. Pe Windows și pe Linux,
 * combinația e `Ctrl+K` — ascultătorul din `ui-store` acceptă de la început ambele
 * (`event.metaKey || event.ctrlKey`), doar afișajul mințea. Un operator pe Ubuntu citea
 * un simbol care nu apare pe tastatura lui.
 *
 * Se citește o singură dată, la prima cerere: platforma nu se schimbă în timpul sesiunii,
 * iar apelul stă în randare.
 */

let cached: string | undefined;

type NavigatorWithUaData = Navigator & { userAgentData?: { platform?: string } };

function detectPlatform(): string {
  if (typeof navigator === 'undefined') {
    return '';
  }

  // `navigator.platform` e depreciat, dar e singurul disponibil peste tot; `userAgentData`
  // există doar pe Chromium și e cel corect când există.
  const nav = navigator as NavigatorWithUaData;
  return nav.userAgentData?.platform || nav.platform || '';
}

/** Mac, iPhone sau iPad — adică unde `⌘` e o tastă reală. */
export function isAppleDevice(): boolean {
  return /mac|iphone|ipad|ipod/i.test(detectPlatform());
}

/**
 * `⌘` pe Apple, `Ctrl` în rest. Nu e un simbol de aceeași lățime cu restul, deci cine îl
 * afișează îl pune într-un `<kbd>` care nu presupune un singur caracter.
 */
export function getModifierKeyLabel(): string {
  cached ??= isAppleDevice() ? '⌘' : 'Ctrl';
  return cached;
}
